import { render, staticRenderFns } from "./DetailBudgetTask.vue?vue&type=template&id=307bd47c"
import script from "./DetailBudgetTask.vue?vue&type=script&lang=js"
export * from "./DetailBudgetTask.vue?vue&type=script&lang=js"
import style0 from "./DetailBudgetTask.vue?vue&type=style&index=0&id=307bd47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports